import { Component, OnInit, Input, EventEmitter, Output, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GenericConversation, GenericConversationCnstrc } from '../../../models/thirdparty-conversation-item';
import { ThirdpartyConversationService } from '../../../services/thirdparty-conversation.service';
import { AuthService } from '../../../core/auth/_services/auth.service';
import { environment } from '../../../../environments';
import { MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'kt-conversation-manager',
	templateUrl: './conversation-manager.component.html',
	styleUrls: ['./conversation-manager.component.scss']
})
export class ConversationManagerComponent<T extends GenericConversation> implements OnInit {
	// Set icon class name
	@Input() icon: string = 'flaticon2-bell-alarm-symbol';
	@Input() iconType: '' | 'success';

	// Set bg image path
	bgImage: string;

	type: 'brand' | 'success' = 'success';

	_contextId: BehaviorSubject<number>;
	@Input() set contextId(value: number) {
		this._contextId.next(value);
	}
	get contextId(): number {
		return this._contextId.getValue();
	}

	@Input() protectedMode: boolean = false;
	@Input() currentAnswerId: number = 0;

	newMessages: boolean = false;
	newMessageCount: number = 0;

	// Conversation items
	_conversationItems$: BehaviorSubject<T[]>;
	@Input() set conversationItems(value) {
		this._conversationItems$.next(this.orderMessageItems(value));
	};
	get conversationItems() {
		return this._conversationItems$.getValue();
	};

	@Input() conversationItemClass: GenericConversationCnstrc;

	currentUserId: number;

	@Output() message: EventEmitter<T> = new EventEmitter();
	@Output() messageDequeue: EventEmitter<T> = new EventEmitter();

	/**
	 * Component constructor
	 */
	constructor(
		private _conversationService: ThirdpartyConversationService,
		private matDialog: MatDialog,
		private _authService: AuthService
	) {
		this._conversationItems$ = new BehaviorSubject<T[]>([]);
		this.currentUserId = this._authService.userId;
		this.bgImage = environment.assets.notificationBackground;
		this._contextId = new BehaviorSubject<number>(0);
	}

	ngOnInit(): void {
		// Cheching new messages
		this._conversationItems$.subscribe(x => {

			var index = this.orderMessageItems(x)
				.findIndex(msg => msg.userId == this.currentUserId);

			this.newMessageCount = index >= 0 ? index : x.length;
			this.newMessages = this.newMessageCount > 0;
		});

		if (!this.conversationItemClass) {
			throw "Please especify a Conversation Item Class";
		}
	}

	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}

	enqueueMessage(message: string) {
		console.log(this.currentAnswerId)
		var msgItem = (new this.conversationItemClass(message, this.currentAnswerId ?? this.contextId, this.currentUserId)) as T;
		msgItem.canBeDeleted = true;
		// console.log(msgItem)
		
		// Generating event with new conversation
		this.message.emit(msgItem);

		this.conversationItems.push(msgItem);
		// reasigning for orderning list
		this.conversationItems = this.conversationItems;
	}

	private orderMessageItems(unordered: T[]): T[] {
		// ordenamiento por fecha desc.
		return unordered.sort((a, b) => a.createDate <= b.createDate ? 1 : -1);
	}

	deleteMessage(message: T) {
		this.conversationItems = this.conversationItems.filter(x => x.id !== message.id);
		this.messageDequeue.emit(message);
	}

	openDialogWithTemplateRef(templateRef: TemplateRef<any>) {
		this.matDialog.open(templateRef, {
			panelClass: "mat-dialog-no-padding"
		});
	}
}
